import { Button, Icon, PillBadge } from '@platform/components';
import { ApplicationResultContent } from '../../components/ApplicationResultContent';
import { getProgramNameFromParam } from '../../../util/ProgramHelpers';
import {
  ProfessionalApplicationStatusResponseClientUrlParam,
  ProfessionalApplicationStatusResponseCohortKickoffDate,
} from '@platform/client/schemas';
export const ApplicationApproved = ({
  cohortKickoffDate,
  clientUrlParam,
}: {
  cohortKickoffDate: ProfessionalApplicationStatusResponseCohortKickoffDate;
  clientUrlParam: ProfessionalApplicationStatusResponseClientUrlParam;
}) => {
  const programName = getProgramNameFromParam(clientUrlParam);
  const programNameStr =
    clientUrlParam && !['ey', 'individual'].includes(clientUrlParam) ?
      `the ${programName}`
    : programName;
  return (
    <ApplicationResultContent
      title="You're in!"
      description={
        <div className='flex flex-col gap-8'>
          <p className='text-xl -mt-6'>Welcome to {programNameStr}. We're excited to have you.</p>
          {cohortKickoffDate && <KickOffReminderCard kickoffDate={cohortKickoffDate} />}
          <p className='text-base -mb-2'>
            Explore your dashboard to get started. It will help you track your progress and stay
            connected throughout the cohort.
          </p>
          <Button
            variant='primary'
            size='lg'
            additionalClassnames='w-full'
            href={`platform/dashboard`}
          >
            See my dashboard
          </Button>
        </div>
      }
    />
  );
};

const KickOffReminderCard = ({ kickoffDate }: { kickoffDate: string }) => {
  const kickoffAsDate = new Date(kickoffDate);
  const weekofStr = `Week of ${kickoffAsDate.toLocaleString('default', { month: 'long' })} ${kickoffAsDate.getDate()}`;
  return (
    <div className='w-full bg-secondary-brand-25 rounded-xl p-4 text-gray-600'>
      <h3 className='text-lg font-semibold mb-4'>Don't forget to...</h3>
      <div className='flex gap-4'>
        <div className='w-10 h-10 bg-success-500 text-success-25 rounded-full flex items-center justify-center'>
          <Icon type='calendar-check-01' size='20' />
        </div>
        <div>
          <div className='flex gap-2'>
            <h4 className='text-base font-semibold'>Join the kickoff call</h4>
            <PillBadge variant='plain' size='sm' color='success-25'>
              {weekofStr}
            </PillBadge>
          </div>
          <p>Keep an eye on your email, we'll send you the details soon!</p>
        </div>
      </div>
    </div>
  );
};
